import { render, staticRenderFns } from "./ApproveLeadCreditRequests.vue?vue&type=template&id=2ccab2e2&"
import script from "./ApproveLeadCreditRequests.vue?vue&type=script&lang=js&"
export * from "./ApproveLeadCreditRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports